import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  showCustomToast,
  CustomToastContainer,
} from "../../components/CustomToast";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";

const User_statefoodlicense = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDocument, setShowDocument] = useState(null);
  const statusEnum = ["In-Progress", "Submitted", "Rejected", "Completed"];
  const navigate = useNavigate(); // Use navigate to redirect
  const [files, setFiles] = useState({});
  const [licenseData, setLicenseData] = useState({
    licenseRequireYears: "",
    fullName: "",
    businessName: "",
    natureOfBusiness: "",
    ownerQualification: "",
    email: "",
    mobileNumber: "",
    businessAddress: "",
    formPrice: "",
    application_type: "",
    submitNote: "",
    completedNote: "",
    Status: "In-Progress",
    rejectedNote: "",
    statusHistory:"",
  });

  const [documents, setDocuments] = useState({
    aadharCard: null,
    panCard: null,
    photo: null,
    electricBill: null,
    rentAggrement: null,
    shopActLicense: null,
    signature:null,
  });

  useEffect(() => {
   
    const fetchLicenseData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://api.makeeasydocuments.com/api/stateFoodLicense/getStateFoodLicense/${id}`
        );
        const data = response.data;
        setLicenseData({
          fullName: data.fullName || "",
          businessName: data.businessName || "",
          natureOfBusiness: data.natureOfBusiness || "",
          ownerQualification: data.ownerQualification || "",
          email: data.email || "",
          mobileNumber: data.mobileNumber || "",
          businessAddress: data.businessAddress || "",
          licenseRequireYears: data.licenseRequireYears || "",
          formPrice: data.formPrice || "",
          application_type: data.application_type || "",
          submitNote: data.submitNote || "",
          completedNote: data.completedNote || "",
          Status: data.Status || "In-Progress",
          rejectedNote: data.rejectedNote || "",
          createdAt: data.createdAt || "",
          updatedAt: data.updatedAt || "",
          documents: data.documents || {}, 
          statusHistory:data.statusHistory||"",// Assign documents properly here
        });
        console.log("data of gst", data)
      } catch (err) {
        console.error("Error fetching state food license data: ", err);
        setError("Error fetching license data", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchLicenseData();
  }, [id]);

  const handleUpdate = async (event) => {
    event.preventDefault();

 // Update the status to "In-Progress"
 const updatedLicenseData = { ...licenseData, Status: "In-Progress" };
 const formData = new FormData();

    for (const key in updatedLicenseData) {
      if (updatedLicenseData.hasOwnProperty(key)) {
        // Skip the documents and user objects
        if (key !== 'documents' && key !== 'user') {
          // Handle dates specially
          if (updatedLicenseData[key] instanceof Date) {
            formData.append(key, updatedLicenseData[key].toISOString());
          }
          // Handle primitive values
          else if (typeof updatedLicenseData[key] !== 'object') {
            formData.append(key, updatedLicenseData[key]);
          }
        }
      }
    }

     // If you need to send the user ID, send it properly
     if (updatedLicenseData.user && updatedLicenseData.user._id) {
      formData.append('user', updatedLicenseData.user._id);
    }

    console.log("User Data:", licenseData.user);
    console.log("Updated Status:", updatedLicenseData.Status);

    // Append files to formData
    for (const [key, value] of Object.entries(files)) {
      if (value instanceof File) {
        formData.append(`documents.${key}`, value);
      }
    }

    // Log the FormData content for debugging
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    // Update the status to "In-Progress"
    try {
      const response = await axios.put(
        `https://api.makeeasydocuments.com/api/stateFoodLicense/updatestatefoodlicense/${id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log("after put", response.data);
      setTimeout(() => {
        navigate("/dashboard/my_application");
      }, 4001);
      showCustomToast(response.data.message);
    } catch (error) {
      showCustomToast("Failed to update license.", error);
    }
  };

  const renderImage = (imageData) => {
    try {
      // Check if all required properties exist and are valid
      if (
        imageData && 
        imageData.contentType && 
        imageData.data && 
        imageData.data.data && 
        Array.isArray(imageData.data.data)
      ) {
        const byteArray = new Uint8Array(imageData.data.data);
        const base64String = btoa(
          Array.from(byteArray)
            .map(byte => String.fromCharCode(byte))
            .join('')
        );
        return `data:${imageData.contentType};base64,${base64String}`;
      }
      console.log("Invalid image data:", imageData);
      return null;
    } catch (error) {
      console.error("Error rendering image:", error);
      return null;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLicenseData({ ...licenseData, [name]: value });
  };


  const handleFileChange = (event) => {
    const { name, files } = event.target;
    setFiles((prevFiles) => ({
      ...prevFiles,
      [name]: files[0],
    }));
  };
  const DocumentPreviewModal = ({ document, onClose }) => {
    if (!document) return null;
  
    // Check if document is a string (URL) or an object
    const documentUrl = typeof document === 'string' ? document : null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full">
          <h2>Download The Documents From Here...</h2>
          
          {documentUrl && (
            <div className="my-4">
              <img 
                src={documentUrl} 
                className="max-w-full max-h-96 mx-auto"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = ""; // Placeholder for failed image load
                  // e.target.alt = "Unable to preview document";
                }}
              />
            </div>
          )}
  
          <div className="mt-4 flex justify-between">
            <button
              className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600"
              onClick={onClose}
            >
              Close
            </button>
            {documentUrl && (
              
                <a href={documentUrl}
                download
                className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700"
              >
                Download
              </a>
            )}
          </div>
        </div>
      </div>
    );
  };

  const DownloadableDocuments = () => {
    console.log("License Data Documents:", licenseData.documents); // Debug log
    if (!licenseData.documents) return null; // Ensure documents is defined

    const { receipt, finisheddoc } = licenseData.documents;

    const status = licenseData.Status;

    return (
   
      <div className="col-span-3 bg-white shadow-md p-6 rounded-lg mb-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">
        Downloadable Documents
      </h2>
      {(status === "Submitted" || status === "Completed") && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {(status === "Submitted" || status === "Completed") ? (
            <div className="border p-4 rounded-lg text-center bg-gray-50">
              <h3 className="font-semibold mb-2">Receipt</h3>
              <button
                  className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                  onClick={() => {
                    const imageUrl = renderImage(receipt);
                    setShowDocument(imageUrl);
                  }}
                >
                  View Receipt
                </button>
            </div>
          ) : (
            <div className="hidden sm:block"></div> // Placeholder to maintain layout
          )}
          {status === "Completed" && finisheddoc ? (
            <div className="border p-4 rounded-lg text-center bg-gray-50">
              <h3 className="font-semibold mb-2">Finished Document</h3>
              <button
                className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                onClick={() => setShowDocument(renderImage(finisheddoc))}
              >
                View Document
              </button>
            </div>
          ) : (
            <div className="hidden sm:block"></div> // Placeholder to maintain layout
          )}
        </div>
      )}
    </div>
    );
  };

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error)
    return <div className="text-center mt-10 text-red-500">{error}</div>;

  const labelClass = "block text-sm mb-2 font-medium text-gray-700";
  const inputClass = "border border-gray-300 rounded-md p-2 w-full";

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white shadow-xl rounded-lg overflow-hidden">
          <div className="px-4 py-5 sm:p-6">
            <h1 className="text-3xl font-bold text-center text-gray-900 mb-8">
              State Food License
            </h1>
            <DownloadableDocuments />

            <form onSubmit={handleUpdate} className="space-y-6">
              {/* Row 1: License Require Years, Full Name, Business Name */}
              <div className="flex space-x-4">
                <div className="flex-1">
                  <label className={labelClass} htmlFor="licenseRequireYears">
                    License Require Years
                  </label>
                  <input
                    id="licenseRequireYears"
                    name="licenseRequireYears"
                    type="text"
                    className={inputClass}
                    value={licenseData.licenseRequireYears}
                    onChange={handleInputChange}
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
                <div className="flex-1">
                  <label className={labelClass} htmlFor="fullName">
                    Full Name
                  </label>
                  <input
                    id="fullName"
                    name="fullName"
                    type="text"
                    className={inputClass}
                    value={licenseData.fullName}
                    onChange={handleInputChange}
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
                <div className="flex-1">
                  <label className={labelClass} htmlFor="businessName">
                    Business Name
                  </label>
                  <input
                    id="businessName"
                    name="businessName"
                    type="text"
                    className={inputClass}
                    value={licenseData.businessName}
                    onChange={handleInputChange}
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
              </div>

              {/* Row 2: Nature of Business, Owner Qualification, Mobile Number */}
              <div className="flex space-x-4">
                <div className="flex-1">
                  <label className={labelClass} htmlFor="natureOfBusiness">
                    Nature of Business
                  </label>
                  <input
                    id="natureOfBusiness"
                    name="natureOfBusiness"
                    type="text"
                    className={inputClass}
                    value={licenseData.natureOfBusiness}
                    onChange={handleInputChange}
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
                <div className="flex-1">
                  <label className={labelClass} htmlFor="ownerQualification">
                    Owner Qualification
                  </label>
                  <input
                    id="ownerQualification"
                    name="ownerQualification"
                    type="text"
                    className={inputClass}
                    value={licenseData.ownerQualification}
                    onChange={handleInputChange}
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
                <div className="flex-1">
                  <label className={labelClass} htmlFor="mobileNumber">
                    Mobile Number
                  </label>
                  <input
                    id="mobileNumber"
                    name="mobileNumber"
                    type="text"
                    className={inputClass}
                    value={licenseData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
              </div>

              {/* Row 3: Business Address, Status, Rejected Note */}
              <div className="flex space-x-4">
                <div className="flex-1">
                  <label className={labelClass} htmlFor="businessAddress">
                    Business Address
                  </label>
                  <input
                    id="businessAddress"
                    name="businessAddress"
                    type="text"
                    className={inputClass}
                    value={licenseData.businessAddress}
                    onChange={handleInputChange}
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
                <div className="flex-1">
                  <label className={labelClass} htmlFor="email">
                    email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="text"
                    className={inputClass}
                    value={licenseData.email}
                    onChange={handleInputChange}
                    required
                    disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                  />
                </div>
              </div>

              {/* Document Uploads */}
              <form onSubmit={handleUpdate} className="space-y-6">
                {/* Other input fields */}

                {/* Document Uploads in One Row */}
                <div className="flex space-x-4">
                  <div className="flex-1">
                    <label className={labelClass} htmlFor="aadharCard">
                      Aadhar Card
                    </label>
                    <input
                      id="aadharCard"
                      name="aadharCard"
                      type="file"
                      className={inputClass}
                      accept="image/*"
                      onChange={handleFileChange}
                      disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                    />
                  </div>

                  <div className="flex-1">
                    <label className={labelClass} htmlFor="panCard">
                      Pan Card
                    </label>
                    <input
                      id="panCard"
                      name="panCard"
                      type="file"
                      className={inputClass}
                      accept="image/*"
                      onChange={handleFileChange}
                      disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                    />
                  </div>

                  <div className="flex-1">
                    <label className={labelClass} htmlFor="photo">
                      Photo
                    </label>
                    <input
                      id="photo"
                      name="photo"
                      type="file"
                      className={inputClass}
                      accept="image/*"
                      onChange={handleFileChange}
                      disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                    />
                  </div>
                </div>
                <div className="flex space-x-4">
                  <div className="flex-1">
                    <label className={labelClass} htmlFor="electricBill">
                      Electric Bill
                    </label>
                    <input
                      id="electricBill"
                      name="electricBill"
                      type="file"
                      className={inputClass}
                      accept="image/*"
                      onChange={handleFileChange}
                      disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                    />
                  </div>

                  <div className="flex-1">
                    <label className={labelClass} htmlFor="rentAggrement">
                      Rent Aggrement
                    </label>
                    <input
                      id="rentAggrement"
                      name="rentAggrement"
                      type="file"
                      className={inputClass}
                      accept="image/*"
                      onChange={handleFileChange}
                      disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                    />
                  </div>
                  <div className="flex-1">
                    <label className={labelClass} htmlFor="shopActLicense">
                      Shop ActLicense
                    </label>
                    <input
                      id="shopActLicense"
                      name="shopActLicense"
                      type="file"
                      className={inputClass}
                      accept="image/*"
                      onChange={handleFileChange}
                      disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                    />
                  </div>
                  
                  <div className="flex-1">
                    <label className={labelClass} htmlFor="signature">
                    Signature
                    </label>
                    <input
                      id="signature"
                      name="signature"
                      type="file"
                      className={inputClass}
                      accept="image/*"
                      onChange={handleFileChange}
                      disabled={licenseData.Status !== "Rejected"} // Disable if status is not "Rejected"
                    />
                  </div>
                </div>
              </form>

              {/* Application History */}
              <div className="bg-green-50 shadow-md p-6 rounded-lg w-full lg:w-full space-y-4">
                <h2 className="text-xl text-center font-bold mb-4 text-gray-700 border-b-2 border-gray-400 pb-2">
                  Application History
                </h2>

                <div className="flex justify-between text-gray-800">
                  <strong className="text-gray-600 flex-1">
                    Created At (Date & Time):
                  </strong>
                  <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                    {new Date(licenseData.createdAt).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true,
                    })}
                  </span>
                </div>

                <div className="flex justify-between text-gray-800">
                  <strong className="text-gray-600 flex-1">
                    Updated At (Date & Time):
                  </strong>
                  <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                    {licenseData.updatedAt
                      ? new Date(licenseData.updatedAt).toLocaleString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          }
                        )
                      : "N/A"}
                  </span>
                </div>

                <div className="flex justify-between text-gray-800">
                  <strong className="text-gray-600 flex-1">
                    Current Status:
                  </strong>
                  <span className="flex-1 text-center text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                    {licenseData.Status ? licenseData.Status : "N/A"}
                  </span>
                </div>

            {/* history */}
                {/* Display history regardless of Status */}
                <div className="flex justify-between text-gray-800">
                  <div className="text-gray-600 flex-1">
                    <strong className="text-gray-600">Status History:</strong>
                  </div>

                  {/* Display for new schema with statusHistory */}
                  {licenseData.statusHistory && licenseData.statusHistory.length > 0 ? (
                    <div className="flex-1 text-gray-700 border border-gray-300 bg-gray-50 p-1 rounded">
                      {licenseData.statusHistory.map((statusChange, index) => (
                        <div
                          key={index}
                          className={`p-3 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} border-b border-gray-300 last:border-b-0`}
                        >
                          <div className="flex justify-between items-center mb-1">
                            <span className="text-sm font-medium text-gray-500">
                              Changed on: {new Date(statusChange.changedAt).toLocaleString()}
                            </span>
                            <span className={`text-xs font-semibold px-2 py-1 rounded ${statusChange.status === 'Rejected' ? 'bg-red-100 text-red-800' :
                                statusChange.status === 'Submitted' ? 'bg-blue-100 text-blue-800' :
                                  statusChange.status === 'Completed' ? 'bg-green-100 text-green-800' :
                                    'bg-yellow-100 text-yellow-800'
                              }`}>
                              {statusChange.status}
                            </span>
                          </div>
                          <p className="text-gray-700">{statusChange.note || "No additional notes"}</p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    // Fallback for when no status history exists
                    <div className="text-center text-gray-500 border border-gray-300 bg-gray-50 p-3 rounded">
                      No status history available
                    </div>
                  )}
                </div>            
            </div>
             
               {licenseData.Status === "Rejected" && (
                <div>
                  <button
                    type="submit"
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                  >
                    Update Application
                  </button>
                </div>
              )}
            </form>

            <DocumentPreviewModal
              document={showDocument}
              onClose={() => setShowDocument(null)}
            />
          </div>
        </div>
      </div>
      <CustomToastContainer />
    </div>
  );
};

export default User_statefoodlicense;
